import { useCallback } from "react";

export const useChangeHistoryFormatter = () => {
  const formatDate = useCallback((dateString?: string) => {
    if (!dateString) return "N/A";
    try {
      return new Date(dateString).toLocaleString("en-US", {
        year: "numeric",
        month: "short",
        day: "numeric",
        hour: "2-digit",
        minute: "2-digit"
      });
    } catch {
      return dateString;
    }
  }, []);

  const getOperationLabel = useCallback((operation: string) => {
    const map: { [key: string]: string } = {
      create: "Created",
      update: "Updated",
      delete: "Deleted",
      calculate: "Calculated",
      download: "Downloaded"
    };
    return map[operation] || "Modified";
  }, []);

  const getOperationBg = useCallback((operation: string) => {
    const map: { [key: string]: string } = {
      create: "tw-bg-foreground/5 tw-border-l-primary",
      update: "tw-bg-foreground/5 tw-border-l-primary",
      delete: "tw-bg-foreground/5 tw-border-l-destructive"
    };
    return map[operation] || "tw-bg-foreground/5 tw-border-l-border";
  }, []);

  return {
    formatDate,
    getOperationLabel,
    getOperationBg
  };
};
